<div class="calendar">
  <div class="calendar__header">
    <div class="calendar__prev calendar__change-month" (click)="prevMonth()">
      <i class="icon-arrow-left"></i>
    </div>
    <div class="calendar__month-year">{{ currentMonthYear().month }}, {{ currentMonthYear().year }}</div>
    <div class="calendar__next calendar__change-month" (click)="nextMonth()">
      <i class="icon-arrow-right"></i>
    </div>
  </div>

  <div class="calendar__grid">
    <div class="calendar__days">
      @for (name of dayNames; track name; let i = $index) {
      <div class="calendar__day p9" [class.calendar__day_weekend]="i > 4">
        {{ name }}
      </div>
      }
    </div>

    <div class="calendar__weeks">
      @for (week of weeks(); track week) {
      <div class="calendar__week">
        @for (day of week; track day.mDate) {
        @if (!isSelectedMonth(day.mDate)) {
        <div class="calendar__week-date calendar__week-date_disabled"
          [class.calendar__week-date_weekend]="isWeekend(day.mDate)">
          <span class="calendar__day-text">{{ day.mDate.date() }}</span>
        </div>
        } @else {
        <div class="calendar__week-date calendar__week-date_enabled" [class.calendar__week-date_today]="day.today"
          [class.calendar__week-date_selected]="isSelected(day.mDate)"
          [class.calendar__week-date_weekend]="isWeekend(day.mDate)" (click)="selectDate(day)">
          <span class="calendar__day-text">{{ day.mDate.date() }}</span>
        </div>
        }
        }
      </div>
      }
    </div>
  </div>

  <div class="calendar__footer">
    <span class="calendar__delete-date" (click)="onClearDay()"> Удалить дату </span>
  </div>
</div>